import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 17"
}, r = /* @__PURE__ */ e("g", { "clip-path": "url(#resend_svg__a)" }, [
  /* @__PURE__ */ e("path", {
    fill: "currentColor",
    d: "m17.005 6.292.002-5.32-2.113 2.113-.237-.237A7.95 7.95 0 0 0 9 .505c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8h-1.548A6.46 6.46 0 0 1 9 14.957a6.46 6.46 0 0 1-6.452-6.452A6.46 6.46 0 0 1 9 2.053a6.4 6.4 0 0 1 4.562 1.89l.237.237-2.113 2.113h5.32Z"
  })
], -1), l = /* @__PURE__ */ e("defs", null, [
  /* @__PURE__ */ e("clipPath", { id: "resend_svg__a" }, [
    /* @__PURE__ */ e("path", {
      fill: "currentColor",
      d: "M.5 0h17v17H.5z"
    })
  ])
], -1), s = [
  r,
  l
];
function c(_, d) {
  return t(), o("svg", n, [...s]);
}
const h = { render: c };
export {
  h as default,
  c as render
};
